import { createContext, useContext, useState, ReactNode } from "react";

export type WhatsAppContext = "generic" | "escola" | "despachante";
export type PopupMode = "whatsapp" | "phone";

interface WhatsAppPopupState {
  isOpen: boolean;
  context: WhatsAppContext;
  mode: PopupMode;
}

interface WhatsAppPopupContextValue {
  state: WhatsAppPopupState;
  openPopup: (context?: WhatsAppContext, mode?: PopupMode) => void;
  closePopup: () => void;
}

const WhatsAppPopupContext = createContext<WhatsAppPopupContextValue | null>(null);

export const WhatsAppPopupProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<WhatsAppPopupState>({
    isOpen: false,
    context: "generic",
    mode: "whatsapp",
  });

  const openPopup = (context: WhatsAppContext = "generic", mode: PopupMode = "whatsapp") => {
    setState({ isOpen: true, context, mode });
  };

  const closePopup = () => {
    setState((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <WhatsAppPopupContext.Provider value={{ state, openPopup, closePopup }}>
      {children}
    </WhatsAppPopupContext.Provider>
  );
};

export const useWhatsAppPopup = (): WhatsAppPopupContextValue => {
  const ctx = useContext(WhatsAppPopupContext);
  if (!ctx) throw new Error("useWhatsAppPopup must be used within WhatsAppPopupProvider");
  return ctx;
};
